export const FORM_SUBMITTED = 'FORM_SUBMITTED';

export function formSubmitted() {
  return dispatch => dispatch({
    type: FORM_SUBMITTED,
  });
}
